module.exports = __webpack_public_path__ + "img/IEC13732.c45a84d9.png";